export default "__VITE_ASSET__59b9e709__"